<template>
    <div v-if="data != undefined && !store.notFound" id="container-store-card" class="grid grid-cols-8 gap-4 relative top-2 mx-special max-md:grid-cols-2 max-md:pt-24">
        <DataCardV2 v-for="info in data" data-type="store" :data="info" />
    </div>
    <DatanotFound v-if="store.notFound" :message="t('Not-found')" />
    <NoData v-if="data.length < 1 && !store.notFound" :message="t('No-data-products')"/>
    <router-view />
</template>

<script setup>
import { onBeforeMount, onMounted, ref, watchEffect } from 'vue';
import { generalStore } from '@/stores';
import { productStore } from '@/stores/product';
import DatanotFound from '@/components/utils/DatanotFound.vue';
import NoData from '@/components/utils/NoData.vue';
import DataCardV2 from '@/components/utils/DataCardV2.vue';
import { useTranslation } from 'i18next-vue';

const {t} = useTranslation();
const store = generalStore();
const storeP = productStore();

var data = ref([]);

onMounted(async () => {
    data.value = await storeP.getAllProducts();
})

onBeforeMount(() => {
    window.scrollTo(top);
})

store.setIsPP(false);

watchEffect(() => {
    if ((store.filterC) || (store.filterN)) {
        data.value = store.getFiltered();
    } else {
        if (storeP.getProducts() != undefined) {
            data.value = storeP.getProducts();
        }
    }
})
</script>